import React from "react";

interface ArticleImageProps {
  image: string;
  title: string;
  height?: number | string;
}

const ArticleImage: React.FC<ArticleImageProps> = ({
  image,
  title,
  height = "80px",
}) => {
  return (
    <div
      className="rounded"
      style={{ position: "relative", width: "100%", overflow: "hidden" }}
    >
      <img
        src={image}
        alt="article"
        className="object-cover w-full rounded"
        style={{ height, width: "100%", display: "block" }}
      />
      <div
        className="text-white"
        style={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          width: "100%",
          background: "rgba(0,0,0,0.45)",
          fontSize: "0.5rem",
          padding: "0.1rem 0.2rem",
          borderBottomLeftRadius: "0.5rem",
          borderBottomRightRadius: "0.5rem",
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          textAlign: "left",
          boxSizing: "border-box",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden",
          paddingLeft: 16,
        }}
      >
        {title}
      </div>
    </div>
  );
};

export default ArticleImage;
